import { RouteTransfer } from '@/types/RouteTransferType';
import { InjectionKey, Ref, ref, ComputedRef, computed } from 'vue';
import { QuoteDetails } from '@/types/QuoteType';
import { CompanyInformation } from '@/types/CompanyInformationType';
import { WalletType } from '@/types/WalletType';
import { valuesRouteTransfer } from '@/modules/transaction/constants/routeTransfer.constant';
import { Transaction } from '@/types/TransactionType';

export interface CashInProvider {
  originRoute: Ref<RouteTransfer>;
  destinationRoute: Ref<RouteTransfer>;
  transactionData: Ref<Transaction>;
  updateTransactionData: (transactionDataUpdate: Transaction) => void;
  navigateTo(valueStep: string): void;
  quoteData: Ref<QuoteDetails>;
  moduleType?: 'CASHIN' | 'REMITTANCE' | '';
  companyInformation?: Ref<CompanyInformation>;
  messageSecureText?: ComputedRef<string>;
  wallet: Ref<WalletType>;
};

export const initialValuesCashInProvider: CashInProvider = {
  originRoute: ref(valuesRouteTransfer),
  transactionData: ref({} as Transaction),
  destinationRoute: ref(valuesRouteTransfer),
  updateTransactionData: () => undefined,
  navigateTo: () => undefined,
  quoteData: ref({} as QuoteDetails),
  moduleType: '',
  companyInformation: ref({} as CompanyInformation),
  messageSecureText: computed(() => 'Sistema seguro'),
  wallet: ref({} as WalletType),
};

export const transactionProviderKey: InjectionKey<CashInProvider> =
  Symbol('transaction');

export default transactionProviderKey;
